module.exports = __webpack_public_path__ + "img/posologie-bertil-schema.7adc80a8.png";